// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAvailabilityStyles } from "@bg/Overrides/Components/ProductAvailability";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productAvailabilityStyles.warehouseModelIcon = {
    size: 13,
    color: "tertiary.main",
    src: "Info2",
    css: css`
        margin-right: 4px;
        svg {
            fill: ${getColor("tertiary.main")};
        }
    `,
};
